import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateUser from "../mutations/CreateUser";
import { useMutation } from "@apollo/client";
import AllUsers from "../queries/AllUsers";
import Select from "react-select";

// reactstrap
import {
  Form,
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
} from "reactstrap";

const CreateUserForm = () => {
  const navigate = useNavigate();
  const [user_name, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedTrialType, setSelectedTrialType] = useState(null);
  const [errors, setErrors] = useState([]);

  const [addUser] = useMutation(CreateUser);

  const colors = [
    "Red",
    "Blue",
    "Green",
    "Yellow",
    "Orange",
    "Purple",
    "Pink",
    "Teal",
    "Coral",
    "Cyan",
  ];
  const animals = [
    "Dog",
    "Cat",
    "Bird",
    "Fish",
    "Rabbit",
    "Turtle",
    "Horse",
    "Mouse",
    "Duck",
    "Goat",
    "Cow",
    "Pig",
    "Lion",
    "Monkey",
    "Bear",
    "Deer",
    "Sheep",
    "Fox",
    "Wolf",
    "Zebra",
  ];

  const generatePassword = () => {
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const randomAnimal = animals[Math.floor(Math.random() * animals.length)];
    const generated = randomColor + randomAnimal;

    console.log("trying to generate: ", generated);
    setPassword(generated);
  };

  const handleMutation = (variables) => {
    addUser({
      variables: variables,
      refetchQueries: [{ query: AllUsers }],
    })
      .then((result) => {
        console.log("Mutation result: ", result);
        navigate("/users");
      })
      .catch((error) => {
        console.log("Mutation error:", error);
        const resultString = error.message
          .substring(error.message.indexOf(":"))
          .trim()
          .replace(/"/g, "");

        setErrors([resultString]);
      });
  };

  function onSubmit() {
    let newErrors = [];

    if (user_name === "") {
      console.log("no user name");
      newErrors.push("Please input a User Name");
    }

    if (selectedLanguage === null) {
      console.log("no role");
      newErrors.push("Please input a language");
    }

    if (selectedTrialType === null) {
      console.log("no role");
      newErrors.push("Please input a trial type");
    }

    if (password === "") {
      console.log("no password");
      newErrors.push("Please input a password");
    }

    if (role === "") {
      console.log("no role");
      newErrors.push("Please input a role");
    }

    setErrors(newErrors);

    if (newErrors.length === 0) {
      const variables = {
        user_name: user_name,
        password: password,
        role: role,
        survey_language: selectedLanguage.value,
        trial_type: selectedTrialType.value,
      };

      console.log("variables: ", variables);

      handleMutation(variables);

      setErrors([]);
    }
    setUserName("");
    setPassword("");
    setRole("");
    setSelectedRole(null);
    setSelectedLanguage(null);
    setSelectedTrialType(null);
  }

  return (
    <>
      <Card className="bg-secondary shadow">
        <CardHeader className="bg-white border-0">
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-0">User Form</h3>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Form>
            <h6 className="heading-small text-muted mb-4">User credentials</h6>
            <Row>
              <Col lg="5">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-username"
                  >
                    Username
                  </label>
                  <Input
                    value={user_name}
                    onChange={(e) => setUserName(e.target.value)}
                    className="form-control-alternative"
                    id="input-username"
                    placeholder="Username"
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col lg="5">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-password"
                  >
                    Password
                  </label>
                  <Input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control-alternative"
                    id="input-password"
                    placeholder="Password"
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col lg="2">
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    generatePassword();
                  }}
                >
                  Generate Password
                </Button>
              </Col>
            </Row>
            <hr className="my-4" />
            <h6 className="heading-small text-muted mb-4">User Access</h6>
            <Row>
              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-role">
                    Role
                  </label>
                  <Select
                    placeholder="Role"
                    value={selectedRole}
                    onChange={(selectedRole) => {
                      setSelectedRole(selectedRole);
                      setRole(selectedRole.value);
                    }}
                    options={[
                      {
                        value: "user",
                        label: "User",
                      },
                      {
                        value: "admin",
                        label: "Admin",
                      },
                      {
                        value: "report_viewer",
                        label: "Report Viewer",
                      },
                    ]}
                    className="form-control-alternative"
                    id="input-role"
                  />
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-lang">
                    Language
                  </label>
                  <Select
                    placeholder="Language"
                    value={selectedLanguage}
                    onChange={(selectedLanguage) => {
                      setSelectedLanguage(selectedLanguage);
                    }}
                    options={[
                      {
                        value: "arabic",
                        label: "Arabic",
                      },
                      {
                        value: "korean",
                        label: "Korean",
                      },
                      {
                        value: "russian",
                        label: "Russian",
                      },
                    ]}
                    className="form-control-alternative"
                    id="input-lang"
                  />
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-trial">
                    Trial Type
                  </label>
                  <Select
                    placeholder="Trial Type"
                    value={selectedTrialType}
                    onChange={(selectedTrialType) => {
                      setSelectedTrialType(selectedTrialType);
                    }}
                    options={[
                      {
                        value: "individual",
                        label: "Individual",
                      },
                      {
                        value: "group",
                        label: "Group",
                      },
                    ]}
                    className="form-control-alternative"
                    id="input-trial"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              className="text-danger"
              style={{
                height: "24px",
              }}
            >
              {errors.map((error) => (
                <div key={error}>{error}</div>
              ))}
            </div>
            <hr className="my-4" />
            <Button
              color="primary"
              onClick={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              Submit
            </Button>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};

export default CreateUserForm;
